"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OpenMapButton: ()=>OpenMapButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const MetadataManager_js_namespaceObject = require("../MarkdownComponent/MetadataManager.js");
const OpenMapButton = ({ isLoading, isStandalone })=>{
    const { shouldUseMapFeature } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const hotelOnMapList = MetadataManager_js_namespaceObject.inlineMetadataManager.getHotelOnMapList();
    const locationPinList = MetadataManager_js_namespaceObject.inlineMetadataManager.getLocationPinList();
    const [hasPinOnMap, setHasPinOnMap] = (0, external_react_namespaceObject.useState)(false);
    const { setIsMapOpened, shouldDisplayMapButton } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    (0, external_react_namespaceObject.useEffect)(()=>{
        const hasPinOnMap = hotelOnMapList?.length > 0 || locationPinList?.length > 0;
        if (hasPinOnMap && isStandalone) setIsMapOpened(true);
        setHasPinOnMap(hasPinOnMap);
    }, [
        isStandalone,
        hotelOnMapList,
        locationPinList,
        setIsMapOpened
    ]);
    if (!shouldUseMapFeature || !hasPinOnMap || isLoading || !shouldDisplayMapButton) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
            mt: 3,
            mb: 4,
            style: {
                position: 'relative'
            },
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                size: "small",
                style: {
                    position: 'absolute',
                    bottom: '0',
                    left: '50%',
                    transform: 'translate(-50%, 15px)'
                },
                onClick: function() {
                    analytics_js_default().fireGA4Event({
                        event: 'map_click',
                        attributes: {
                            type: 'penny',
                            page_name: 'listings',
                            product_name: 'hotel'
                        }
                    });
                    setIsMapOpened(true);
                },
                title: "Open Map",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Map, {
                            color: "lightest",
                            size: 16
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                            ml: 1,
                            children: "Map"
                        })
                    ]
                })
            })
        })
    });
};
exports.OpenMapButton = __webpack_exports__.OpenMapButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OpenMapButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
